
export const FORM_CONSTANTS = {
  CREACION: {
    FORM_CLASS: 'card-header-danger',
    FORM_TITLE: 'Registro de zarpe',
    FORM_BUTTON: 'Guardar zarpe',
  },
  EDICION: {
    FORM_CLASS: 'card-header-primary',
    FORM_TITLE: 'Edición de zarpe',
    FORM_BUTTON: 'Actualizar',
  }
};
